import Vue from 'vue'
import Router from 'vue-router'
import Index from '../views/Index.vue'

Vue.use(Router)

let routes = []

const routerContext = require.context('./', true, /index\.js$/)

routerContext.keys().forEach(route => {
  // 如果是根目录的 index.js、 不做任何处理
  if (route.startsWith('./index')) {
    return
  }
  const routerModule = routerContext(route)
  // 兼容 import export 和 require module.export 两种规范  Es modules  commonjs
  routes = [...routes, ...(routerModule.default || routerModule)]
})

routes = [
  {
    path: '/',
    component: Index
  },
  ...routes
]

export default new Router({
  // mode: 'history',
  // base:'/dist',
  //base: process.env.BASE_URL,
  routes: routes
})